import * as ChatConstants from '../../action/chat/ChatConstants';

const initialState = {
  chatDataIsLoading: false,
  chatDataSuccess: [],
  chatDataErrorMessage: '',

  addChatMessageIsLoading: false,
  addChatMessageSuccess: {},
  addChatErrorMessage: '',

  discardQcIsLoading: false,
  discardQcData: {},
  discardQcErrorMessage: '',

  discardFrIsLoading: false,
  discardFrData: {},
  discardFrErrorMessage: ''
};

export const chatStore = (state = initialState, action) => {
  switch (action.type) {
    case ChatConstants.GET_CHAT_DATA_REQUEST:
      return {
        ...state,
        chatDataIsLoading: true,
        chatDataErrorMessage: ''
      };
    case ChatConstants.GET_CHAT_DATA_SUCCESS:
      return {
        ...state,
        chatDataIsLoading: false,
        chatData: action.data
      };
    case ChatConstants.GET_CHAT_DATA_FAILED:
      return {
        ...state,
        chatDataIsLoading: false,
        chatDataErrorMessage: 'SERVER ERROR'
      };

    case ChatConstants.ADD_CHAT_MESSAGE_REQUEST:
      return {
        ...state,
        addChatMessageIsLoading: true,
        chatDataErrorMessage: ''
      };
    case ChatConstants.ADD_CHAT_MESSAGE_SUCCESS:
      return {
        ...state,
        addChatMessageIsLoading: false,
        addChatMessageSuccess: action.data
      };
    case ChatConstants.ADD_CHAT_MESSAGE_FAILED:
      return {
        ...state,
        addChatMessageIsLoading: false,
        addChatErrorMessage: 'SEND MESSAGE FAILED'
      };

    case ChatConstants.DISCARD_QC_REQUEST:
      return {
        ...state,
        discardQcIsLoading: true,
        discardQcErrorMessage: ''
      };
    case ChatConstants.DISCARD_QC_SUCCESS:
      return {
        ...state,
        discardQcIsLoading: false,
        discardQcData: action.data
      };
    case ChatConstants.DISCARD_QC_FAILED:
      return {
        ...state,
        discardQcIsLoading: false,
        discardQcErrorMessage: 'SERVER ERROR'
      };

    case ChatConstants.DISCARD_FR_REQUEST:
      return {
        ...state,
        discardFrIsLoading: true,
        discardFrErrorMessage: ''
      };
    case ChatConstants.DISCARD_FR_SUCCESS:
      return {
        ...state,
        discardFrIsLoading: false,
        discardFrData: action.data
      };
    case ChatConstants.DISCARD_FR_FAILED:
      return {
        ...state,
        discardFrIsLoading: false,
        discardFrErrorMessage: 'SERVER ERROR'
      };

    default:
      return state;
  }
};
